import React, { PropsWithChildren } from 'react';
import { Icon } from '@common/components';

type Props = {
  password?: string;
};

export function PasswordValidationFeedback({ password = '' }: Props) {
  if (!password?.length) {
    return false;
  }

  return (
    <div className="password-validation-feedback">
      <ValidatorIndicator rule={() => password.length >= 8}>
        Minimum of eight characters
      </ValidatorIndicator>
      <ValidatorIndicator rule={() => password.match(/(?=.*[a-z])/)}>
        At least one lowercase letter (a,z)
      </ValidatorIndicator>
      <ValidatorIndicator rule={() => password.match(/(?=.*[A-Z])/)}>
        At least one uppercase letter (A,Z)
      </ValidatorIndicator>
      <ValidatorIndicator rule={() => password.match(/(?=.*\d)/)}>
        At least one numeric character (0-9)
      </ValidatorIndicator>
      <ValidatorIndicator rule={() => password.match(/(?=.*[!%@#$%])/)}>
        At least one special character (!, @, #, $, or %)
      </ValidatorIndicator>
    </div>
  );
}

type ValidatorIndicatorProps = {
  rule: () => boolean | RegExpMatchArray | null;
};

export function ValidatorIndicator({
  rule,
  children,
}: PropsWithChildren<ValidatorIndicatorProps>) {
  return (
    <div className="validator-indicator">
      {rule() ? (
        <Icon icon="circleCheck" kind="regular" color="grass" size="md" />
      ) : (
        <Icon icon="circleX" kind="regular" color="coral" size="md" />
      )}
      {children}
      <style jsx>{`
        .validator-indicator :global(.wk-icon) {
          margin-right: 8px;
        }
      `}</style>
    </div>
  );
}
